import { normalize } from 'normalizr';
import { combineEpics, ofType } from 'redux-observable';
import { catchError, from, map, mergeMap } from 'rxjs';
import { EpicDeletCartData } from 'src/js/enrol/epics/EpicDeletCartData';
import { EpicSyncCartPayers } from 'src/js/enrol/epics/EpicSyncCartPayers';
import { EpicSyncCheckoutModel } from 'src/js/enrol/epics/EpicSyncCheckoutModel';
import EpicSyncFieldValues from 'src/js/enrol/epics/EpicSyncFieldValues';
import { IshAction } from '../../actions/IshAction';
import { mapError, mapPayload } from '../../common/epics/EpicUtils';
import { IshActions } from '../../constants/IshActions';
import { Injector } from '../../injector';
import { ContactSchema } from '../../NormalizeSchema';
import { EpicGetConcessionTypes } from '../containers/concession/epics/EpicGetConcessionTypes';
import { GetContactConcessions } from '../containers/concession/epics/EpicGetContactConcessions';
import { AddPayerFromVoucher, SubmitAddContact } from '../containers/contact-add/epics/EpicSubmitAddContact';
import { OpenEditContact } from '../containers/contact-edit/epics/EpicOpenEditContact';
import { SubmitEditContact } from '../containers/contact-edit/epics/EpicSubmitEditContact';
import { EpicPayment } from '../containers/payment/epics/EpicPayment';
import { EpicResult } from '../containers/result/epics/EpicResult';
import { AddContactToSummary } from '../containers/summary/epics/EpicAddContactToSummary';
import { EpicUpdateParentChilds } from '../containers/summary/epics/EpicUpdateParentChilds';
import { EpicAddCode } from './EpicAddCode';
import { EpicChangePayNow } from './EpicChangePayNow';
import { FinishCheckoutProcess } from './EpicFinishCheckoutProcess';
import { GetAllContactNodes } from './EpicGetAllContactNodes';
import { EpicGetCartData } from './EpicGetCartData';
import { GetContactNode } from './EpicGetContactNode';
import { EpicInit } from './EpicInit';
import { EpicItemSelect } from './EpicItemSelect';
import { EpicUpdateSummary } from './EpicLoadCheckoutModel';
import { EpicProceedToPayment } from './EpicProceedToPayment';
import { EpicProcessingMandatoryFields } from './EpicProcessingMandatoryFields';
import EpicRefreshRedeemVouchers from './EpicRefreshRedeemVouchers';
import { EpicRemoveContact } from './EpicRemoveContact';
import { EpicStoreCartState } from './EpicStoreCartState';
import { EpicToggleRedeemVoucher } from './EpicToggleRedeemVoucher';
import EpicToggleRedeemVoucherProduct from './EpicToggleRedeemVoucherProduct';
import { EpicUpdateAmount } from './EpicUpdateAmount';
import { EpicUpdateEnrolmentFields } from './EpicUpdateEnrolmentFields';
import MessagesShowEpic from './MessagesShowEpic';

const {
  contactApi,
} = Injector;

export const EpicCheckout = combineEpics(
  EpicInit,
  EpicSyncCheckoutModel,
  MessagesShowEpic,
  SubmitAddContact,
  AddPayerFromVoucher,
  SubmitEditContact,
  OpenEditContact,
  GetContactNode,
  GetAllContactNodes,
  EpicAddCode,
  AddContactToSummary,
  EpicRemoveContact,
  EpicItemSelect,
  EpicUpdateAmount,
  EpicChangePayNow,
  EpicUpdateSummary,
  EpicRefreshRedeemVouchers,
  EpicProceedToPayment,
  EpicPayment,
  EpicGetConcessionTypes,
  GetContactConcessions,
  FinishCheckoutProcess,
  EpicResult,
  EpicToggleRedeemVoucher,
  EpicToggleRedeemVoucherProduct,
  EpicUpdateParentChilds,
  createGetOrCreateContactEpic(IshActions.GET_OR_CREATE_CONTACT),
  EpicUpdateEnrolmentFields,
  EpicProcessingMandatoryFields,
  EpicSyncFieldValues,
  EpicStoreCartState,
  EpicSyncCartPayers,
  EpicDeletCartData,
  EpicGetCartData,
);

function createGetOrCreateContactEpic(actionType) {
  return action$ => action$.pipe(
    ofType(actionType),
    mergeMap<IshAction, any>(action => from(contactApi.createOrGetContact(action.payload)).pipe(
      map(payload => normalize(payload, ContactSchema)),
      map(mapPayload(actionType)),
      catchError(mapError(actionType))  
    )) 
  );
}
